var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVegetarisch = function SvgVegetarisch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vegetarisch"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g261-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path263-0",
    d: "M3.38315 12.9745L5.23469 12.9524L8.59104 9.74548M6.19433 12.0362L6.42786 13.9135M5.2578 6.52868C5.26179 6.29107 5.2849 6.05499 5.32635 5.8212C5.97195 2.16726 9.21115 0.954104 9.50526 1.00132C9.78024 1.04549 12.102 2.9311 11.8868 6.15323M8.0371 4.67277L8.71459 5.48383L8.36548 7.46006M8.48902 6.76476L9.8719 6.15323M10.2322 8.626C11.0244 8.05103 12.0765 7.92309 12.9939 8.28939C16.1494 9.29312 17.2023 11.8611 16.9688 12.5312C16.7456 13.171 14.4772 14.5372 11.5058 13.7596M11.3982 10.7568L12.0606 10.967L12.7612 12.3066M11.7091 10.8558L13.1111 10.1857M3.26837 9.74548C4.96289 8.12642 6.89971 8.12642 8.59423 9.74548C10.2888 11.3645 10.2888 13.2151 8.59423 14.8342C5.4475 17.8408 1.57465 16.9155 1.33155 16.6832C1.08925 16.451 0.118451 12.7521 3.26837 9.74548Z",
    stroke: "currentColor",
    strokeWidth: 1.23467,
    strokeMiterlimit: 34.043,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
export default SvgVegetarisch;